const trackingDetails = {
  accountSwitcherLinkInMenuClicked: 'Account Switcher Link In Menu Clicked',
  accountSwitcherLinkInTableClicked: 'Account Switcher Link In Table Clicked',
  aiNavButtonClicked: 'Ask AI Nav Button Clicked',
  articleInternalLinkClicked: 'Article Internal Link Clicked',
  articleExternalLinkClicked: 'Article External Link Clicked',
  authContactSupport: 'Authenticated Contact Support',
  categoryArticleLinkClicked: 'Category Article Link Clicked',
  categoryViewMoreClicked: 'Category View More Clicked',
  categoriesViewMore: 'Categories View More Clicked',
  deflectionSearchSubmit: 'Deflection Search Submit',
  escalateTicket: 'Escalate ticket',
  loginToConsole: 'Header Login Clicked',
  navigateToConsole: 'Header Navigate to Console',
  recommendedResultFound: 'Recommended Result Found',
  recommendedResultClicked: 'Recommended Result Clicked',
  sectionArticleLinkClicked: 'Section Article Link Clicked',
  sectionViewMoreClicked: 'Section View More Clicked',
  selectDeflectionSuggestion: (suggestionNumber: number): string =>
    `Select Deflection Suggestion ${suggestionNumber}`,
  signUpToTwilio: 'Header Sign Up Clicked',
  sidebarNavigation: {
    homeClicked: 'Sidebar Navigation Item Clicked - Home',
    ticketSubmissionClicked:
      'Sidebar Navigation Item Clicked - Submit a ticket',
    supportPlansClicked: 'Sidebar Navigation Item Clicked - Support plans',
    ticketHistoryClicked: 'Sidebar Navigation Item Clicked - Ticket history',
  },
  statusPageLinkClick: 'Status Page Link Clicked',
  subaccountLinkInTableClicked: 'Subaccount Link In Table Clicked',
  subaccountFiltersApplied: 'Subaccount Filters Applied',
  subaccountFiltersCleared: 'Subaccount Filters Cleared',
  subaccountNextPageClicked: 'Subaccount Next Page Clicked',
  subaccountPreviousPageClicked: 'Subaccount Previous Page Clicked',
  submitSupportRequestForm: {
    gated: 'Gated - Submit Support Request Form',
    ungated: 'Ungated - Submit Support Request Form',
  },
  submitTicketComment: 'Submit Ticket Comment',
  ticketHistoryFilterApplied: 'Ticket History Filter Applied',
  unauthContactSupportLogin: 'Unauthenticated Contact Support Login',
  unauthContactSupportTroubleLoggingIn:
    'Unauthenticated Contact Support Trouble Logging In',
  updateTicketCollaborators: 'Update Ticket Collaborators',
  userFeedbackButton: 'Send User Feedback',
  viewMoreSearchResultsButton: 'View More Search Results',
  viewTicket: 'View Ticket',
  viewTicketNotFound: 'View Ticket - Not Found',
  viewTicketNotAuthorized: 'View Ticket - Not Authorized',
  viewTicketUnknown: 'View Ticket - UnknownError',
  welcomeBannerLinkClick: 'Welcome Banner Article Link Clicked',
};

export { trackingDetails };
